<template>
  <div style="margin-top: 3rem;">

 <!-- https://unsplash.com/photos/F77D9r-qIqU -->
 <!-- https://unsplash.com/photos/lG8ANgv7p2k -->

  <div>
    <b-img src="/public/downloads/directories/images/Monument3.jpg" fluid alt="Monument"></b-img>
  </div>
  <br/>
  <br/>
  <h1>In Memoriam</h1>
  <br/>
  <br/>
  <p>
  Auf dem Bild oben sehen wir das Kriegerdenkmal, das uns an die Gefallenen des ersten Weltkrieg erinnern soll. Dem
  vaterländischen Gedanken entsprechend hat man sich damals klassenweise freiwillig gemeldet. So auch unsere gesamte
  damalige Aktivitas. <br/>
  <br/>
  29 Bundesbrüder kamen nicht zurück. Einige von denen, die es zurück schafften, trugen bleibende Schäden davon wie
  Dr. Hans Ebbecke, der sein Augenlicht verloren hatte. <br/>
  Auf der Tafel sind namentlich die folgenden Bundesbrüder aufgeführt: <br/>

        <table class="table table-striped table-hover table-bordered dt-responsive nowrap">
            <thead>
                <tr>
                    <th>Name</th>
                </tr>
            </thead>
            <tbody>
              <tr><td>Albert Baumann</td></tr>
              <tr><td>Fritz Becker</td></tr>
              <tr><td>Richard Fritsch</td></tr>
              <tr><td>Otto Greulich</td></tr>
              <tr><td>Leopold Geitz</td></tr>
              <tr><td>Friedrich Geitz </td></tr>
              <tr><td>Wilhelm Häusler</td></tr>
              <tr><td>Josef Hoffmann</td></tr>
              <tr><td>Kurt Lumpp</td></tr>
              <tr><td>Heinrich Metzger</td></tr>
              <tr><td>Herbert Metzger</td></tr>
              <tr><td>Otto Ribstein</td></tr>
              <tr><td>Hermann Ruf</td></tr>
              <tr><td>Max Saeger</td></tr>
              <tr><td>Franz Schuler</td></tr>
              <tr><td>Josef Weigl </td></tr>
            </tbody>
        </table>

  </p>
  <br/>
  <br/>
  <p>Jedes Jahr versammeln wir uns am Tag nach der Gründungstagskneipe auf dem Bruchsaler Friedhof und
  besuchen die Gräber unserer verstorbenen Bundesbrüder. Doch nicht alle haben dort ihre letzte Ruhestätte gefunden,
  manche Gräber wurden auch aufgelöst. Daher wollen wir uns hier an Bundesbrüder erinnern, die uns besonders nahe standen.
  Ich habe hier einen bescheidenen Anfang gemacht mit den Namen derjenigen Bundesbrüder, die ich noch persönlich erleben
  durfte und / oder die sich besonders um den Bund verdient gemacht haben. <br/>
  Wer hier Namen vermisst, kann gerne auf mich zukommen.</p>
  <br/>
  <br/>

    <b-table
        striped
        hover
        primary-key="id"
        :items="items" :fields="fields"
     >
           <span slot="name" slot-scope="data" v-html="data.value"></span>
     </b-table>
  </div>
</template>

<script>
  export default {
    data() {
      return {
          fields: [
            {
              key: 'name'
            }
          ],
        items: [ // &#8224; '
          { name: 'Karl Geitz, Kunstmaler (* 16.10.1889) (&#8224; 23.11.1980)'},
          { name: 'Siegfried Seifert, Kaufmann (* 12.10.1913) (&#8224; 21.12.2000)'},
          { name: 'Hanspeter Gesell, Geschäftsführer (* 06.09.1937) (&#8224; 14.10.2005)'},
          { name: 'Werner Nowacki, Tierarzt (* 24.10.1913) (&#8224; 21.09.2011)'},
          { name: 'Klemens Baron, Kaufmann (* 1913) (&#8224; 2013)'},
          { name: 'Dieter Weiler, Rechtsanwalt (* 30.01.1938) (&#8224; 18.10.2017)'},
          { name: 'Peter Johna, Bankkaufmann (* 12.11.1941) (&#8224; 17.11.2019)'},
          { name: 'Rolf Weber, Dr. med. (* 13.06.1945) (&#8224; 19.04.2020)'},
          { name: 'Karl-Eugen Ganninger, Landesbeamter (* 25.12.1942) (&#8224; 29.10.2020)'},
          { name: 'Klaus Bühler, Abgeordneter des Deutschen Bundestages (* 16.01.1941) (&#8224; 03.02.2021)'},
          { name: 'Fritz Kemm, Oberstudienrat (* 18.22.1935) (&#8224; 05.07.2023)'},
          { name: 'Wolfgang Schuhwerk, Apotheker (* 24.03.1937) (&#8224; 11.03.2024)'},
          { name: 'Pius Böser, Lehrer (* 18.10.1950) (&#8224; 30.03.2024)'},
          { name: 'Fritz Kirsch, Lehrer (* 18.10.1950) (&#8224; 30.03.2024)'},
        ]
      }
    }
  }
</script>
